import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type Airline = {
  __typename?: 'Airline';
  aliases: Array<Scalars['String']['output']>;
  callsign?: Maybe<Scalars['String']['output']>;
  homeLink?: Maybe<Scalars['String']['output']>;
  iataCode?: Maybe<Scalars['String']['output']>;
  icaoCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  nameCoalesced?: Maybe<Scalars['String']['output']>;
  shortname?: Maybe<Scalars['String']['output']>;
  wikipediaLink?: Maybe<Scalars['String']['output']>;
};

export type AirlineConnection = {
  __typename?: 'AirlineConnection';
  edges: Array<AirlineEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AirlineEdge = {
  __typename?: 'AirlineEdge';
  cursor: Scalars['String']['output'];
  node: Airline;
};

export type AirlineFilterInput = {
  callsignContains?: InputMaybe<Scalars['String']['input']>;
  hasHomeLink?: InputMaybe<Scalars['Boolean']['input']>;
  hasWikipediaLink?: InputMaybe<Scalars['Boolean']['input']>;
  iataCodeContains?: InputMaybe<Scalars['String']['input']>;
  icaoCodeContains?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  shortnameContains?: InputMaybe<Scalars['String']['input']>;
};

export enum AirlineSortField {
  IataCode = 'iataCode',
  IcaoCode = 'icaoCode',
  NameCoalesced = 'nameCoalesced'
}

export type AirlineSortInput = {
  field: AirlineSortField;
  order: SortOrder;
};

export type Airport = {
  __typename?: 'Airport';
  gpsCode?: Maybe<Scalars['String']['output']>;
  homeLink?: Maybe<Scalars['String']['output']>;
  iataCode?: Maybe<Scalars['String']['output']>;
  iataCodeFormer?: Maybe<Scalars['String']['output']>;
  icaoCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  isoCountry?: Maybe<Scalars['String']['output']>;
  isoRegion?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  localCode?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  timezoneId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  wikipediaLink?: Maybe<Scalars['String']['output']>;
};

export type AirportConnection = {
  __typename?: 'AirportConnection';
  edges: Array<AirportEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AirportEdge = {
  __typename?: 'AirportEdge';
  cursor: Scalars['String']['output'];
  node: Airport;
};

export type AirportFilterInput = {
  airportTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  hasHomeLink?: InputMaybe<Scalars['Boolean']['input']>;
  hasWikipediaLink?: InputMaybe<Scalars['Boolean']['input']>;
  iataCodeContains?: InputMaybe<Scalars['String']['input']>;
  icaoCodeContains?: InputMaybe<Scalars['String']['input']>;
  isoCountryContains?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum AirportSortField {
  IataCode = 'iataCode',
  IcaoCode = 'icaoCode',
  IsoCountry = 'isoCountry',
  Name = 'name',
  NameUnaccented = 'nameUnaccented',
  Type = 'type'
}

export type AirportSortInput = {
  field: AirportSortField;
  order: SortOrder;
};

export enum DistanceUnit {
  Kilometers = 'KILOMETERS',
  Miles = 'MILES',
  NauticalMiles = 'NAUTICAL_MILES'
}

export type Flight = {
  __typename?: 'Flight';
  aircraftType?: Maybe<Scalars['String']['output']>;
  arrival?: Maybe<FlightArrival>;
  cancelled?: Maybe<Scalars['Boolean']['output']>;
  departure?: Maybe<FlightDeparture>;
  distance?: Maybe<FlightDistance>;
  diversion?: Maybe<FlightDiversion>;
  diverted?: Maybe<Scalars['Boolean']['output']>;
  durationMinutes?: Maybe<Scalars['Int']['output']>;
  hasActuals?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  identifiers?: Maybe<FlightIdentifiers>;
  marketingAirline?: Maybe<Airline>;
  marketingAirlineId?: Maybe<Scalars['String']['output']>;
  operatingAirline?: Maybe<Airline>;
  operatingAirlineId?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<Scalars['String']['output']>;
  trackId?: Maybe<Scalars['String']['output']>;
  userFlight?: Maybe<UserFlight>;
  userFlightId?: Maybe<Scalars['String']['output']>;
};

export type FlightArrival = {
  __typename?: 'FlightArrival';
  airport?: Maybe<Airport>;
  airportId?: Maybe<Scalars['String']['output']>;
  arrivalTimeCoalesced?: Maybe<Scalars['String']['output']>;
  gateArrivalDelayMinutes?: Maybe<Scalars['Int']['output']>;
  gateArrivalTimeActual?: Maybe<Scalars['String']['output']>;
  gateArrivalTimeScheduled?: Maybe<Scalars['String']['output']>;
  landingDelayMinutes?: Maybe<Scalars['Int']['output']>;
  landingTimeActual?: Maybe<Scalars['String']['output']>;
  landingTimeScheduled?: Maybe<Scalars['String']['output']>;
  runway?: Maybe<Scalars['String']['output']>;
};

export type FlightConnection = {
  __typename?: 'FlightConnection';
  edges: Array<FlightEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlightDeparture = {
  __typename?: 'FlightDeparture';
  airport?: Maybe<Airport>;
  airportId?: Maybe<Scalars['String']['output']>;
  departureDateScheduledLocal?: Maybe<Scalars['String']['output']>;
  departureTimeCoalesced?: Maybe<Scalars['String']['output']>;
  gateDepartureDelayMinutes?: Maybe<Scalars['Int']['output']>;
  gateDepartureTimeActual?: Maybe<Scalars['String']['output']>;
  gateDepartureTimeScheduled?: Maybe<Scalars['String']['output']>;
  generalDatetime?: Maybe<Scalars['String']['output']>;
  generalDatetimePrecision?: Maybe<Scalars['String']['output']>;
  runway?: Maybe<Scalars['String']['output']>;
  takeoffDelayMinutes?: Maybe<Scalars['Int']['output']>;
  takeoffTimeActual?: Maybe<Scalars['String']['output']>;
  takeoffTimeScheduled?: Maybe<Scalars['String']['output']>;
};

export type FlightDistance = {
  __typename?: 'FlightDistance';
  greatCircleKm?: Maybe<Scalars['Float']['output']>;
  routeKm?: Maybe<Scalars['Float']['output']>;
};

export type FlightDiversion = {
  __typename?: 'FlightDiversion';
  airport?: Maybe<Airport>;
  airportId?: Maybe<Scalars['String']['output']>;
  gateArrivalTimeActual?: Maybe<Scalars['String']['output']>;
  landingTimeActual?: Maybe<Scalars['String']['output']>;
  runway?: Maybe<Scalars['String']['output']>;
};

export type FlightEdge = {
  __typename?: 'FlightEdge';
  cursor: Scalars['String']['output'];
  node: Flight;
};

export type FlightIdentifiers = {
  __typename?: 'FlightIdentifiers';
  ident?: Maybe<Scalars['String']['output']>;
  identCoalesced?: Maybe<Scalars['String']['output']>;
  identFlightnumber?: Maybe<Scalars['String']['output']>;
  identIata?: Maybe<Scalars['String']['output']>;
  identIcao?: Maybe<Scalars['String']['output']>;
  marketingIdentIata?: Maybe<Scalars['String']['output']>;
};

export enum FlightSortField {
  ArrivalTime = 'arrivalTime',
  DepartureTime = 'departureTime',
  Distance = 'distance',
  Duration = 'duration'
}

export type FlightSortInput = {
  field: FlightSortField;
  order: SortOrder;
};

export type Mutation = {
  __typename?: 'Mutation';
  deleteUserFlight: Scalars['Boolean']['output'];
  updateUserProfile: User;
};


export type MutationDeleteUserFlightArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateUserProfileArgs = {
  input: UpdateUserProfileInput;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  currentPage: Scalars['Int']['output'];
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
  totalPages: Scalars['Int']['output'];
};

export type PaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type Query = {
  __typename?: 'Query';
  airline?: Maybe<Airline>;
  airlines: AirlineConnection;
  airlinesByIds: Array<Airline>;
  airport?: Maybe<Airport>;
  airports: AirportConnection;
  airportsByIds: Array<Airport>;
  flight?: Maybe<Flight>;
  flights: FlightConnection;
  userAirlineStats: UserAirlineStatsConnection;
  userAirportStats: UserAirportStatsConnection;
  userDistinctCounts: UserDistinctCounts;
  userProfile?: Maybe<User>;
};


export type QueryAirlineArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAirlinesArgs = {
  filter?: InputMaybe<AirlineFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<AirlineSortInput>;
};


export type QueryAirlinesByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryAirportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAirportsArgs = {
  filter?: InputMaybe<AirportFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<AirportSortInput>;
};


export type QueryAirportsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryFlightArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFlightsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<FlightSortInput>;
};


export type QueryUserAirlineStatsArgs = {
  filter?: InputMaybe<UserAirlineStatsFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<UserAirlineStatsSortInput>;
};


export type QueryUserAirportStatsArgs = {
  filter?: InputMaybe<UserAirportStatsFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<UserAirportStatsSortInput>;
};


export type QueryUserDistinctCountsArgs = {
  includeFutureFlights?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export enum TravelClass {
  Business = 'BUSINESS',
  DomesticBusiness = 'DOMESTIC_BUSINESS',
  DomesticFirst = 'DOMESTIC_FIRST',
  Economy = 'ECONOMY',
  First = 'FIRST',
  IntlBusiness = 'INTL_BUSINESS',
  IntlFirst = 'INTL_FIRST',
  PremiumEconomy = 'PREMIUM_ECONOMY',
  Private = 'PRIVATE'
}

export type UpdateUserProfileInput = {
  distanceUnit?: InputMaybe<DistanceUnit>;
  homeAirportId?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  admin: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  distanceUnit: DistanceUnit;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  homeAirport?: Maybe<Airport>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type UserAirlineStats = {
  __typename?: 'UserAirlineStats';
  airline: Airline;
  flightCountFuture: Scalars['Int']['output'];
  flightCountPast: Scalars['Int']['output'];
  lastFlightDate?: Maybe<Scalars['String']['output']>;
  totalDistanceKmFuture: Scalars['Float']['output'];
  totalDistanceKmPast: Scalars['Float']['output'];
};

export type UserAirlineStatsConnection = {
  __typename?: 'UserAirlineStatsConnection';
  edges: Array<UserAirlineStatsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserAirlineStatsEdge = {
  __typename?: 'UserAirlineStatsEdge';
  cursor: Scalars['String']['output'];
  node: UserAirlineStats;
};

export type UserAirlineStatsFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum UserAirlineStatsSortField {
  FlightCountPast = 'flightCountPast',
  IataCode = 'iataCode',
  IcaoCode = 'icaoCode',
  LastFlightDate = 'lastFlightDate',
  NameCoalesced = 'nameCoalesced',
  TotalDistanceKmPast = 'totalDistanceKmPast'
}

export type UserAirlineStatsSortInput = {
  field: UserAirlineStatsSortField;
  order: SortOrder;
};

export type UserAirportStats = {
  __typename?: 'UserAirportStats';
  airport: Airport;
  flightCountFuture: Scalars['Int']['output'];
  flightCountPast: Scalars['Int']['output'];
  lastFlightDate?: Maybe<Scalars['String']['output']>;
};

export type UserAirportStatsConnection = {
  __typename?: 'UserAirportStatsConnection';
  edges: Array<UserAirportStatsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserAirportStatsEdge = {
  __typename?: 'UserAirportStatsEdge';
  cursor: Scalars['String']['output'];
  node: UserAirportStats;
};

export type UserAirportStatsFilterInput = {
  airportTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum UserAirportStatsSortField {
  AirportName = 'airportName',
  FlightCountPast = 'flightCountPast',
  IataCode = 'iataCode',
  IcaoCode = 'icaoCode',
  LastFlightDate = 'lastFlightDate',
  Type = 'type'
}

export type UserAirportStatsSortInput = {
  field: UserAirportStatsSortField;
  order: SortOrder;
};

export type UserDistinctCounts = {
  __typename?: 'UserDistinctCounts';
  airlineCount: Scalars['Int']['output'];
  airportCount: Scalars['Int']['output'];
  flightCount: Scalars['Int']['output'];
};

export type UserFlight = {
  __typename?: 'UserFlight';
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  seatNumber?: Maybe<Scalars['String']['output']>;
  travelClass?: Maybe<TravelClass>;
};

export type GetUserProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserProfileQuery = { __typename?: 'Query', userProfile?: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, admin: boolean, distanceUnit: DistanceUnit, createdAt: string, homeAirport?: { __typename?: 'Airport', id: string, name?: string | null, identifier?: string | null, iataCode?: string | null, icaoCode?: string | null } | null } | null };

export type UpdateUserProfileMutationVariables = Exact<{
  input: UpdateUserProfileInput;
}>;


export type UpdateUserProfileMutation = { __typename?: 'Mutation', updateUserProfile: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, admin: boolean, distanceUnit: DistanceUnit, createdAt: string, homeAirport?: { __typename?: 'Airport', id: string, name?: string | null, identifier?: string | null, iataCode?: string | null, icaoCode?: string | null } | null } };

export type AirlineBasicFragment = { __typename?: 'Airline', id: string, name?: string | null, shortname?: string | null, nameCoalesced?: string | null, iataCode?: string | null, icaoCode?: string | null, callsign?: string | null };

export type AirlineDetailFragment = { __typename?: 'Airline', homeLink?: string | null, wikipediaLink?: string | null, aliases: Array<string>, id: string, name?: string | null, shortname?: string | null, nameCoalesced?: string | null, iataCode?: string | null, icaoCode?: string | null, callsign?: string | null };

export type AirlineCompactFragment = { __typename?: 'Airline', id: string, nameCoalesced?: string | null, iataCode?: string | null, icaoCode?: string | null };

export type AirportBasicFragment = { __typename?: 'Airport', id: string, name?: string | null, identifier?: string | null, iataCode?: string | null, icaoCode?: string | null, type?: string | null, latitude?: number | null, longitude?: number | null, isoCountry?: string | null, timezoneId?: string | null };

export type AirportDetailFragment = { __typename?: 'Airport', homeLink?: string | null, wikipediaLink?: string | null, iataCodeFormer?: string | null, gpsCode?: string | null, localCode?: string | null, isoRegion?: string | null, id: string, name?: string | null, identifier?: string | null, iataCode?: string | null, icaoCode?: string | null, type?: string | null, latitude?: number | null, longitude?: number | null, isoCountry?: string | null, timezoneId?: string | null };

export type FlightIdentifiersFragment = { __typename?: 'Flight', identifiers?: { __typename?: 'FlightIdentifiers', ident?: string | null, identIata?: string | null, identIcao?: string | null, marketingIdentIata?: string | null, identFlightnumber?: string | null, identCoalesced?: string | null } | null };

export type FlightDepartureBasicFragment = { __typename?: 'Flight', departure?: { __typename?: 'FlightDeparture', airportId?: string | null, departureTimeCoalesced?: string | null, airport?: { __typename?: 'Airport', id: string, name?: string | null, identifier?: string | null, iataCode?: string | null, icaoCode?: string | null, type?: string | null, latitude?: number | null, longitude?: number | null, isoCountry?: string | null, timezoneId?: string | null } | null } | null };

export type FlightDepartureDetailFragment = { __typename?: 'Flight', departure?: { __typename?: 'FlightDeparture', airportId?: string | null, departureTimeCoalesced?: string | null, departureDateScheduledLocal?: string | null, gateDepartureTimeScheduled?: string | null, gateDepartureTimeActual?: string | null, gateDepartureDelayMinutes?: number | null, takeoffTimeScheduled?: string | null, takeoffTimeActual?: string | null, takeoffDelayMinutes?: number | null, generalDatetime?: string | null, generalDatetimePrecision?: string | null, runway?: string | null, airport?: { __typename?: 'Airport', homeLink?: string | null, wikipediaLink?: string | null, iataCodeFormer?: string | null, gpsCode?: string | null, localCode?: string | null, isoRegion?: string | null, id: string, name?: string | null, identifier?: string | null, iataCode?: string | null, icaoCode?: string | null, type?: string | null, latitude?: number | null, longitude?: number | null, isoCountry?: string | null, timezoneId?: string | null } | null } | null };

export type FlightArrivalBasicFragment = { __typename?: 'Flight', arrival?: { __typename?: 'FlightArrival', airportId?: string | null, arrivalTimeCoalesced?: string | null, airport?: { __typename?: 'Airport', id: string, name?: string | null, identifier?: string | null, iataCode?: string | null, icaoCode?: string | null, type?: string | null, latitude?: number | null, longitude?: number | null, isoCountry?: string | null, timezoneId?: string | null } | null } | null };

export type FlightArrivalDetailFragment = { __typename?: 'Flight', arrival?: { __typename?: 'FlightArrival', airportId?: string | null, arrivalTimeCoalesced?: string | null, landingTimeScheduled?: string | null, landingTimeActual?: string | null, landingDelayMinutes?: number | null, gateArrivalTimeScheduled?: string | null, gateArrivalTimeActual?: string | null, gateArrivalDelayMinutes?: number | null, runway?: string | null, airport?: { __typename?: 'Airport', homeLink?: string | null, wikipediaLink?: string | null, iataCodeFormer?: string | null, gpsCode?: string | null, localCode?: string | null, isoRegion?: string | null, id: string, name?: string | null, identifier?: string | null, iataCode?: string | null, icaoCode?: string | null, type?: string | null, latitude?: number | null, longitude?: number | null, isoCountry?: string | null, timezoneId?: string | null } | null } | null };

export type FlightDiversionFragment = { __typename?: 'Flight', diversion?: { __typename?: 'FlightDiversion', airportId?: string | null, landingTimeActual?: string | null, gateArrivalTimeActual?: string | null, runway?: string | null, airport?: { __typename?: 'Airport', homeLink?: string | null, wikipediaLink?: string | null, iataCodeFormer?: string | null, gpsCode?: string | null, localCode?: string | null, isoRegion?: string | null, id: string, name?: string | null, identifier?: string | null, iataCode?: string | null, icaoCode?: string | null, type?: string | null, latitude?: number | null, longitude?: number | null, isoCountry?: string | null, timezoneId?: string | null } | null } | null };

export type FlightBasicFragment = { __typename?: 'Flight', id: string, durationMinutes?: number | null, aircraftType?: string | null, operatingAirlineId?: string | null, marketingAirlineId?: string | null, distance?: { __typename?: 'FlightDistance', greatCircleKm?: number | null } | null, operatingAirline?: { __typename?: 'Airline', id: string, name?: string | null, shortname?: string | null, nameCoalesced?: string | null, iataCode?: string | null, icaoCode?: string | null, callsign?: string | null } | null, marketingAirline?: { __typename?: 'Airline', id: string, name?: string | null, shortname?: string | null, nameCoalesced?: string | null, iataCode?: string | null, icaoCode?: string | null, callsign?: string | null } | null, identifiers?: { __typename?: 'FlightIdentifiers', ident?: string | null, identIata?: string | null, identIcao?: string | null, marketingIdentIata?: string | null, identFlightnumber?: string | null, identCoalesced?: string | null } | null, departure?: { __typename?: 'FlightDeparture', airportId?: string | null, departureTimeCoalesced?: string | null, airport?: { __typename?: 'Airport', id: string, name?: string | null, identifier?: string | null, iataCode?: string | null, icaoCode?: string | null, type?: string | null, latitude?: number | null, longitude?: number | null, isoCountry?: string | null, timezoneId?: string | null } | null } | null, arrival?: { __typename?: 'FlightArrival', airportId?: string | null, arrivalTimeCoalesced?: string | null, airport?: { __typename?: 'Airport', id: string, name?: string | null, identifier?: string | null, iataCode?: string | null, icaoCode?: string | null, type?: string | null, latitude?: number | null, longitude?: number | null, isoCountry?: string | null, timezoneId?: string | null } | null } | null };

export type FlightDetailFragment = { __typename?: 'Flight', registration?: string | null, trackId?: string | null, cancelled?: boolean | null, diverted?: boolean | null, hasActuals?: boolean | null, userFlightId?: string | null, id: string, durationMinutes?: number | null, aircraftType?: string | null, operatingAirlineId?: string | null, marketingAirlineId?: string | null, operatingAirline?: { __typename?: 'Airline', id: string, name?: string | null, shortname?: string | null, nameCoalesced?: string | null, iataCode?: string | null, icaoCode?: string | null, callsign?: string | null } | null, marketingAirline?: { __typename?: 'Airline', id: string, name?: string | null, shortname?: string | null, nameCoalesced?: string | null, iataCode?: string | null, icaoCode?: string | null, callsign?: string | null } | null, distance?: { __typename?: 'FlightDistance', routeKm?: number | null, greatCircleKm?: number | null } | null, userFlight?: { __typename?: 'UserFlight', id: string, seatNumber?: string | null, travelClass?: TravelClass | null, notes?: string | null } | null, departure?: { __typename?: 'FlightDeparture', airportId?: string | null, departureTimeCoalesced?: string | null, departureDateScheduledLocal?: string | null, gateDepartureTimeScheduled?: string | null, gateDepartureTimeActual?: string | null, gateDepartureDelayMinutes?: number | null, takeoffTimeScheduled?: string | null, takeoffTimeActual?: string | null, takeoffDelayMinutes?: number | null, generalDatetime?: string | null, generalDatetimePrecision?: string | null, runway?: string | null, airport?: { __typename?: 'Airport', homeLink?: string | null, wikipediaLink?: string | null, iataCodeFormer?: string | null, gpsCode?: string | null, localCode?: string | null, isoRegion?: string | null, id: string, name?: string | null, identifier?: string | null, iataCode?: string | null, icaoCode?: string | null, type?: string | null, latitude?: number | null, longitude?: number | null, isoCountry?: string | null, timezoneId?: string | null } | null } | null, arrival?: { __typename?: 'FlightArrival', airportId?: string | null, arrivalTimeCoalesced?: string | null, landingTimeScheduled?: string | null, landingTimeActual?: string | null, landingDelayMinutes?: number | null, gateArrivalTimeScheduled?: string | null, gateArrivalTimeActual?: string | null, gateArrivalDelayMinutes?: number | null, runway?: string | null, airport?: { __typename?: 'Airport', homeLink?: string | null, wikipediaLink?: string | null, iataCodeFormer?: string | null, gpsCode?: string | null, localCode?: string | null, isoRegion?: string | null, id: string, name?: string | null, identifier?: string | null, iataCode?: string | null, icaoCode?: string | null, type?: string | null, latitude?: number | null, longitude?: number | null, isoCountry?: string | null, timezoneId?: string | null } | null } | null, diversion?: { __typename?: 'FlightDiversion', airportId?: string | null, landingTimeActual?: string | null, gateArrivalTimeActual?: string | null, runway?: string | null, airport?: { __typename?: 'Airport', homeLink?: string | null, wikipediaLink?: string | null, iataCodeFormer?: string | null, gpsCode?: string | null, localCode?: string | null, isoRegion?: string | null, id: string, name?: string | null, identifier?: string | null, iataCode?: string | null, icaoCode?: string | null, type?: string | null, latitude?: number | null, longitude?: number | null, isoCountry?: string | null, timezoneId?: string | null } | null } | null, identifiers?: { __typename?: 'FlightIdentifiers', ident?: string | null, identIata?: string | null, identIcao?: string | null, marketingIdentIata?: string | null, identFlightnumber?: string | null, identCoalesced?: string | null } | null };

export type ListAirlinesMinimalQueryVariables = Exact<{
  filter?: InputMaybe<AirlineFilterInput>;
  sort?: InputMaybe<AirlineSortInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ListAirlinesMinimalQuery = { __typename?: 'Query', airlines: { __typename?: 'AirlineConnection', totalCount: number, edges: Array<{ __typename?: 'AirlineEdge', cursor: string, node: { __typename?: 'Airline', id: string, name?: string | null, shortname?: string | null, nameCoalesced?: string | null, iataCode?: string | null, icaoCode?: string | null, callsign?: string | null } }>, pageInfo: { __typename?: 'PageInfo', currentPage: number, totalPages: number, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetAirlineDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAirlineDetailQuery = { __typename?: 'Query', airline?: { __typename?: 'Airline', homeLink?: string | null, wikipediaLink?: string | null, aliases: Array<string>, id: string, name?: string | null, shortname?: string | null, nameCoalesced?: string | null, iataCode?: string | null, icaoCode?: string | null, callsign?: string | null } | null };

export type GetAirlinesMinimalQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetAirlinesMinimalQuery = { __typename?: 'Query', airlinesByIds: Array<{ __typename?: 'Airline', id: string, name?: string | null, shortname?: string | null, nameCoalesced?: string | null, iataCode?: string | null, icaoCode?: string | null, callsign?: string | null }> };

export type GetUserAirlineStatsQueryVariables = Exact<{
  filter?: InputMaybe<UserAirlineStatsFilterInput>;
  sort?: InputMaybe<UserAirlineStatsSortInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetUserAirlineStatsQuery = { __typename?: 'Query', userAirlineStats: { __typename?: 'UserAirlineStatsConnection', totalCount: number, edges: Array<{ __typename?: 'UserAirlineStatsEdge', cursor: string, node: { __typename?: 'UserAirlineStats', flightCountPast: number, flightCountFuture: number, totalDistanceKmPast: number, totalDistanceKmFuture: number, lastFlightDate?: string | null, airline: { __typename?: 'Airline', id: string, nameCoalesced?: string | null, iataCode?: string | null, icaoCode?: string | null } } }>, pageInfo: { __typename?: 'PageInfo', currentPage: number, totalPages: number, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetUserDistinctCountsQueryVariables = Exact<{
  includeFutureFlights?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetUserDistinctCountsQuery = { __typename?: 'Query', userDistinctCounts: { __typename?: 'UserDistinctCounts', airlineCount: number, flightCount: number, airportCount: number } };

export type ListAirportsMinimalQueryVariables = Exact<{
  filter?: InputMaybe<AirportFilterInput>;
  sort?: InputMaybe<AirportSortInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ListAirportsMinimalQuery = { __typename?: 'Query', airports: { __typename?: 'AirportConnection', totalCount: number, edges: Array<{ __typename?: 'AirportEdge', cursor: string, node: { __typename?: 'Airport', id: string, name?: string | null, identifier?: string | null, iataCode?: string | null, icaoCode?: string | null, type?: string | null, latitude?: number | null, longitude?: number | null, isoCountry?: string | null, timezoneId?: string | null } }>, pageInfo: { __typename?: 'PageInfo', currentPage: number, totalPages: number, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetAirportDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAirportDetailQuery = { __typename?: 'Query', airport?: { __typename?: 'Airport', homeLink?: string | null, wikipediaLink?: string | null, iataCodeFormer?: string | null, gpsCode?: string | null, localCode?: string | null, isoRegion?: string | null, id: string, name?: string | null, identifier?: string | null, iataCode?: string | null, icaoCode?: string | null, type?: string | null, latitude?: number | null, longitude?: number | null, isoCountry?: string | null, timezoneId?: string | null } | null };

export type GetAirportsMinimalQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetAirportsMinimalQuery = { __typename?: 'Query', airportsByIds: Array<{ __typename?: 'Airport', id: string, name?: string | null, identifier?: string | null, iataCode?: string | null, icaoCode?: string | null, type?: string | null, latitude?: number | null, longitude?: number | null, isoCountry?: string | null, timezoneId?: string | null }> };

export type GetUserAirportStatsQueryVariables = Exact<{
  filter?: InputMaybe<UserAirportStatsFilterInput>;
  sort?: InputMaybe<UserAirportStatsSortInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetUserAirportStatsQuery = { __typename?: 'Query', userAirportStats: { __typename?: 'UserAirportStatsConnection', totalCount: number, edges: Array<{ __typename?: 'UserAirportStatsEdge', cursor: string, node: { __typename?: 'UserAirportStats', flightCountPast: number, flightCountFuture: number, lastFlightDate?: string | null, airport: { __typename?: 'Airport', id: string, name?: string | null, identifier?: string | null, iataCode?: string | null, icaoCode?: string | null, type?: string | null, latitude?: number | null, longitude?: number | null, isoCountry?: string | null, timezoneId?: string | null } } }>, pageInfo: { __typename?: 'PageInfo', currentPage: number, totalPages: number, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type ListFlightsMinimalQueryVariables = Exact<{
  sort?: InputMaybe<FlightSortInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ListFlightsMinimalQuery = { __typename?: 'Query', flights: { __typename?: 'FlightConnection', totalCount: number, edges: Array<{ __typename?: 'FlightEdge', cursor: string, node: { __typename?: 'Flight', id: string, durationMinutes?: number | null, aircraftType?: string | null, operatingAirlineId?: string | null, marketingAirlineId?: string | null, userFlight?: { __typename?: 'UserFlight', id: string, seatNumber?: string | null, travelClass?: TravelClass | null, notes?: string | null } | null, distance?: { __typename?: 'FlightDistance', greatCircleKm?: number | null } | null, operatingAirline?: { __typename?: 'Airline', id: string, name?: string | null, shortname?: string | null, nameCoalesced?: string | null, iataCode?: string | null, icaoCode?: string | null, callsign?: string | null } | null, marketingAirline?: { __typename?: 'Airline', id: string, name?: string | null, shortname?: string | null, nameCoalesced?: string | null, iataCode?: string | null, icaoCode?: string | null, callsign?: string | null } | null, identifiers?: { __typename?: 'FlightIdentifiers', ident?: string | null, identIata?: string | null, identIcao?: string | null, marketingIdentIata?: string | null, identFlightnumber?: string | null, identCoalesced?: string | null } | null, departure?: { __typename?: 'FlightDeparture', airportId?: string | null, departureTimeCoalesced?: string | null, airport?: { __typename?: 'Airport', id: string, name?: string | null, identifier?: string | null, iataCode?: string | null, icaoCode?: string | null, type?: string | null, latitude?: number | null, longitude?: number | null, isoCountry?: string | null, timezoneId?: string | null } | null } | null, arrival?: { __typename?: 'FlightArrival', airportId?: string | null, arrivalTimeCoalesced?: string | null, airport?: { __typename?: 'Airport', id: string, name?: string | null, identifier?: string | null, iataCode?: string | null, icaoCode?: string | null, type?: string | null, latitude?: number | null, longitude?: number | null, isoCountry?: string | null, timezoneId?: string | null } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', currentPage: number, totalPages: number, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetFlightDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetFlightDetailQuery = { __typename?: 'Query', flight?: { __typename?: 'Flight', registration?: string | null, trackId?: string | null, cancelled?: boolean | null, diverted?: boolean | null, hasActuals?: boolean | null, userFlightId?: string | null, id: string, durationMinutes?: number | null, aircraftType?: string | null, operatingAirlineId?: string | null, marketingAirlineId?: string | null, operatingAirline?: { __typename?: 'Airline', id: string, name?: string | null, shortname?: string | null, nameCoalesced?: string | null, iataCode?: string | null, icaoCode?: string | null, callsign?: string | null } | null, marketingAirline?: { __typename?: 'Airline', id: string, name?: string | null, shortname?: string | null, nameCoalesced?: string | null, iataCode?: string | null, icaoCode?: string | null, callsign?: string | null } | null, distance?: { __typename?: 'FlightDistance', routeKm?: number | null, greatCircleKm?: number | null } | null, userFlight?: { __typename?: 'UserFlight', id: string, seatNumber?: string | null, travelClass?: TravelClass | null, notes?: string | null } | null, departure?: { __typename?: 'FlightDeparture', airportId?: string | null, departureTimeCoalesced?: string | null, departureDateScheduledLocal?: string | null, gateDepartureTimeScheduled?: string | null, gateDepartureTimeActual?: string | null, gateDepartureDelayMinutes?: number | null, takeoffTimeScheduled?: string | null, takeoffTimeActual?: string | null, takeoffDelayMinutes?: number | null, generalDatetime?: string | null, generalDatetimePrecision?: string | null, runway?: string | null, airport?: { __typename?: 'Airport', homeLink?: string | null, wikipediaLink?: string | null, iataCodeFormer?: string | null, gpsCode?: string | null, localCode?: string | null, isoRegion?: string | null, id: string, name?: string | null, identifier?: string | null, iataCode?: string | null, icaoCode?: string | null, type?: string | null, latitude?: number | null, longitude?: number | null, isoCountry?: string | null, timezoneId?: string | null } | null } | null, arrival?: { __typename?: 'FlightArrival', airportId?: string | null, arrivalTimeCoalesced?: string | null, landingTimeScheduled?: string | null, landingTimeActual?: string | null, landingDelayMinutes?: number | null, gateArrivalTimeScheduled?: string | null, gateArrivalTimeActual?: string | null, gateArrivalDelayMinutes?: number | null, runway?: string | null, airport?: { __typename?: 'Airport', homeLink?: string | null, wikipediaLink?: string | null, iataCodeFormer?: string | null, gpsCode?: string | null, localCode?: string | null, isoRegion?: string | null, id: string, name?: string | null, identifier?: string | null, iataCode?: string | null, icaoCode?: string | null, type?: string | null, latitude?: number | null, longitude?: number | null, isoCountry?: string | null, timezoneId?: string | null } | null } | null, diversion?: { __typename?: 'FlightDiversion', airportId?: string | null, landingTimeActual?: string | null, gateArrivalTimeActual?: string | null, runway?: string | null, airport?: { __typename?: 'Airport', homeLink?: string | null, wikipediaLink?: string | null, iataCodeFormer?: string | null, gpsCode?: string | null, localCode?: string | null, isoRegion?: string | null, id: string, name?: string | null, identifier?: string | null, iataCode?: string | null, icaoCode?: string | null, type?: string | null, latitude?: number | null, longitude?: number | null, isoCountry?: string | null, timezoneId?: string | null } | null } | null, identifiers?: { __typename?: 'FlightIdentifiers', ident?: string | null, identIata?: string | null, identIcao?: string | null, marketingIdentIata?: string | null, identFlightnumber?: string | null, identCoalesced?: string | null } | null } | null };

export type DeleteUserFlightMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteUserFlightMutation = { __typename?: 'Mutation', deleteUserFlight: boolean };

export const AirlineBasicFragmentDoc = gql`
    fragment AirlineBasic on Airline {
  id
  name
  shortname
  nameCoalesced
  iataCode
  icaoCode
  callsign
}
    `;
export const AirlineDetailFragmentDoc = gql`
    fragment AirlineDetail on Airline {
  ...AirlineBasic
  homeLink
  wikipediaLink
  aliases
}
    ${AirlineBasicFragmentDoc}`;
export const AirlineCompactFragmentDoc = gql`
    fragment AirlineCompact on Airline {
  id
  nameCoalesced
  iataCode
  icaoCode
}
    `;
export const FlightIdentifiersFragmentDoc = gql`
    fragment FlightIdentifiers on Flight {
  identifiers {
    ident
    identIata
    identIcao
    marketingIdentIata
    identFlightnumber
    identCoalesced
  }
}
    `;
export const AirportBasicFragmentDoc = gql`
    fragment AirportBasic on Airport {
  id
  name
  identifier
  iataCode
  icaoCode
  type
  latitude
  longitude
  isoCountry
  timezoneId
}
    `;
export const FlightDepartureBasicFragmentDoc = gql`
    fragment FlightDepartureBasic on Flight {
  departure {
    airportId
    departureTimeCoalesced
    airport {
      ...AirportBasic
    }
  }
}
    ${AirportBasicFragmentDoc}`;
export const FlightArrivalBasicFragmentDoc = gql`
    fragment FlightArrivalBasic on Flight {
  arrival {
    airportId
    arrivalTimeCoalesced
    airport {
      ...AirportBasic
    }
  }
}
    ${AirportBasicFragmentDoc}`;
export const FlightBasicFragmentDoc = gql`
    fragment FlightBasic on Flight {
  id
  ...FlightIdentifiers
  ...FlightDepartureBasic
  ...FlightArrivalBasic
  durationMinutes
  aircraftType
  distance {
    greatCircleKm
  }
  operatingAirlineId
  operatingAirline {
    ...AirlineBasic
  }
  marketingAirlineId
  marketingAirline {
    ...AirlineBasic
  }
}
    ${FlightIdentifiersFragmentDoc}
${FlightDepartureBasicFragmentDoc}
${FlightArrivalBasicFragmentDoc}
${AirlineBasicFragmentDoc}`;
export const AirportDetailFragmentDoc = gql`
    fragment AirportDetail on Airport {
  ...AirportBasic
  homeLink
  wikipediaLink
  iataCodeFormer
  gpsCode
  localCode
  isoRegion
}
    ${AirportBasicFragmentDoc}`;
export const FlightDepartureDetailFragmentDoc = gql`
    fragment FlightDepartureDetail on Flight {
  departure {
    airportId
    departureTimeCoalesced
    departureDateScheduledLocal
    gateDepartureTimeScheduled
    gateDepartureTimeActual
    gateDepartureDelayMinutes
    takeoffTimeScheduled
    takeoffTimeActual
    takeoffDelayMinutes
    generalDatetime
    generalDatetimePrecision
    runway
    airport {
      ...AirportDetail
    }
  }
}
    ${AirportDetailFragmentDoc}`;
export const FlightArrivalDetailFragmentDoc = gql`
    fragment FlightArrivalDetail on Flight {
  arrival {
    airportId
    arrivalTimeCoalesced
    landingTimeScheduled
    landingTimeActual
    landingDelayMinutes
    gateArrivalTimeScheduled
    gateArrivalTimeActual
    gateArrivalDelayMinutes
    runway
    airport {
      ...AirportDetail
    }
  }
}
    ${AirportDetailFragmentDoc}`;
export const FlightDiversionFragmentDoc = gql`
    fragment FlightDiversion on Flight {
  diversion {
    airportId
    landingTimeActual
    gateArrivalTimeActual
    runway
    airport {
      ...AirportDetail
    }
  }
}
    ${AirportDetailFragmentDoc}`;
export const FlightDetailFragmentDoc = gql`
    fragment FlightDetail on Flight {
  ...FlightBasic
  ...FlightDepartureDetail
  ...FlightArrivalDetail
  ...FlightDiversion
  operatingAirline {
    ...AirlineBasic
  }
  marketingAirline {
    ...AirlineBasic
  }
  registration
  distance {
    routeKm
  }
  trackId
  cancelled
  diverted
  hasActuals
  userFlightId
  userFlight {
    id
    seatNumber
    travelClass
    notes
  }
}
    ${FlightBasicFragmentDoc}
${FlightDepartureDetailFragmentDoc}
${FlightArrivalDetailFragmentDoc}
${FlightDiversionFragmentDoc}
${AirlineBasicFragmentDoc}`;
export const GetUserProfileDocument = gql`
    query GetUserProfile {
  userProfile {
    id
    email
    firstName
    lastName
    admin
    distanceUnit
    createdAt
    homeAirport {
      id
      name
      identifier
      iataCode
      icaoCode
    }
  }
}
    `;

/**
 * __useGetUserProfileQuery__
 *
 * To run a query within a React component, call `useGetUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
      }
export function useGetUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
        }
export function useGetUserProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
        }
export type GetUserProfileQueryHookResult = ReturnType<typeof useGetUserProfileQuery>;
export type GetUserProfileLazyQueryHookResult = ReturnType<typeof useGetUserProfileLazyQuery>;
export type GetUserProfileSuspenseQueryHookResult = ReturnType<typeof useGetUserProfileSuspenseQuery>;
export type GetUserProfileQueryResult = Apollo.QueryResult<GetUserProfileQuery, GetUserProfileQueryVariables>;
export const UpdateUserProfileDocument = gql`
    mutation UpdateUserProfile($input: UpdateUserProfileInput!) {
  updateUserProfile(input: $input) {
    id
    email
    firstName
    lastName
    admin
    distanceUnit
    createdAt
    homeAirport {
      id
      name
      identifier
      iataCode
      icaoCode
    }
  }
}
    `;
export type UpdateUserProfileMutationFn = Apollo.MutationFunction<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;

/**
 * __useUpdateUserProfileMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileMutation, { data, loading, error }] = useUpdateUserProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>(UpdateUserProfileDocument, options);
      }
export type UpdateUserProfileMutationHookResult = ReturnType<typeof useUpdateUserProfileMutation>;
export type UpdateUserProfileMutationResult = Apollo.MutationResult<UpdateUserProfileMutation>;
export type UpdateUserProfileMutationOptions = Apollo.BaseMutationOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const ListAirlinesMinimalDocument = gql`
    query ListAirlinesMinimal($filter: AirlineFilterInput, $sort: AirlineSortInput, $pagination: PaginationInput) {
  airlines(filter: $filter, sort: $sort, pagination: $pagination) {
    edges {
      node {
        ...AirlineBasic
      }
      cursor
    }
    pageInfo {
      currentPage
      totalPages
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    ${AirlineBasicFragmentDoc}`;

/**
 * __useListAirlinesMinimalQuery__
 *
 * To run a query within a React component, call `useListAirlinesMinimalQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAirlinesMinimalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAirlinesMinimalQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListAirlinesMinimalQuery(baseOptions?: Apollo.QueryHookOptions<ListAirlinesMinimalQuery, ListAirlinesMinimalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAirlinesMinimalQuery, ListAirlinesMinimalQueryVariables>(ListAirlinesMinimalDocument, options);
      }
export function useListAirlinesMinimalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAirlinesMinimalQuery, ListAirlinesMinimalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAirlinesMinimalQuery, ListAirlinesMinimalQueryVariables>(ListAirlinesMinimalDocument, options);
        }
export function useListAirlinesMinimalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAirlinesMinimalQuery, ListAirlinesMinimalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAirlinesMinimalQuery, ListAirlinesMinimalQueryVariables>(ListAirlinesMinimalDocument, options);
        }
export type ListAirlinesMinimalQueryHookResult = ReturnType<typeof useListAirlinesMinimalQuery>;
export type ListAirlinesMinimalLazyQueryHookResult = ReturnType<typeof useListAirlinesMinimalLazyQuery>;
export type ListAirlinesMinimalSuspenseQueryHookResult = ReturnType<typeof useListAirlinesMinimalSuspenseQuery>;
export type ListAirlinesMinimalQueryResult = Apollo.QueryResult<ListAirlinesMinimalQuery, ListAirlinesMinimalQueryVariables>;
export const GetAirlineDetailDocument = gql`
    query GetAirlineDetail($id: ID!) {
  airline(id: $id) {
    ...AirlineDetail
  }
}
    ${AirlineDetailFragmentDoc}`;

/**
 * __useGetAirlineDetailQuery__
 *
 * To run a query within a React component, call `useGetAirlineDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAirlineDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAirlineDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAirlineDetailQuery(baseOptions: Apollo.QueryHookOptions<GetAirlineDetailQuery, GetAirlineDetailQueryVariables> & ({ variables: GetAirlineDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAirlineDetailQuery, GetAirlineDetailQueryVariables>(GetAirlineDetailDocument, options);
      }
export function useGetAirlineDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAirlineDetailQuery, GetAirlineDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAirlineDetailQuery, GetAirlineDetailQueryVariables>(GetAirlineDetailDocument, options);
        }
export function useGetAirlineDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAirlineDetailQuery, GetAirlineDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAirlineDetailQuery, GetAirlineDetailQueryVariables>(GetAirlineDetailDocument, options);
        }
export type GetAirlineDetailQueryHookResult = ReturnType<typeof useGetAirlineDetailQuery>;
export type GetAirlineDetailLazyQueryHookResult = ReturnType<typeof useGetAirlineDetailLazyQuery>;
export type GetAirlineDetailSuspenseQueryHookResult = ReturnType<typeof useGetAirlineDetailSuspenseQuery>;
export type GetAirlineDetailQueryResult = Apollo.QueryResult<GetAirlineDetailQuery, GetAirlineDetailQueryVariables>;
export const GetAirlinesMinimalDocument = gql`
    query GetAirlinesMinimal($ids: [ID!]!) {
  airlinesByIds(ids: $ids) {
    ...AirlineBasic
  }
}
    ${AirlineBasicFragmentDoc}`;

/**
 * __useGetAirlinesMinimalQuery__
 *
 * To run a query within a React component, call `useGetAirlinesMinimalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAirlinesMinimalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAirlinesMinimalQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetAirlinesMinimalQuery(baseOptions: Apollo.QueryHookOptions<GetAirlinesMinimalQuery, GetAirlinesMinimalQueryVariables> & ({ variables: GetAirlinesMinimalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAirlinesMinimalQuery, GetAirlinesMinimalQueryVariables>(GetAirlinesMinimalDocument, options);
      }
export function useGetAirlinesMinimalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAirlinesMinimalQuery, GetAirlinesMinimalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAirlinesMinimalQuery, GetAirlinesMinimalQueryVariables>(GetAirlinesMinimalDocument, options);
        }
export function useGetAirlinesMinimalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAirlinesMinimalQuery, GetAirlinesMinimalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAirlinesMinimalQuery, GetAirlinesMinimalQueryVariables>(GetAirlinesMinimalDocument, options);
        }
export type GetAirlinesMinimalQueryHookResult = ReturnType<typeof useGetAirlinesMinimalQuery>;
export type GetAirlinesMinimalLazyQueryHookResult = ReturnType<typeof useGetAirlinesMinimalLazyQuery>;
export type GetAirlinesMinimalSuspenseQueryHookResult = ReturnType<typeof useGetAirlinesMinimalSuspenseQuery>;
export type GetAirlinesMinimalQueryResult = Apollo.QueryResult<GetAirlinesMinimalQuery, GetAirlinesMinimalQueryVariables>;
export const GetUserAirlineStatsDocument = gql`
    query GetUserAirlineStats($filter: UserAirlineStatsFilterInput, $sort: UserAirlineStatsSortInput, $pagination: PaginationInput) {
  userAirlineStats(filter: $filter, sort: $sort, pagination: $pagination) {
    edges {
      node {
        airline {
          ...AirlineCompact
        }
        flightCountPast
        flightCountFuture
        totalDistanceKmPast
        totalDistanceKmFuture
        lastFlightDate
      }
      cursor
    }
    pageInfo {
      currentPage
      totalPages
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    ${AirlineCompactFragmentDoc}`;

/**
 * __useGetUserAirlineStatsQuery__
 *
 * To run a query within a React component, call `useGetUserAirlineStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAirlineStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAirlineStatsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetUserAirlineStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserAirlineStatsQuery, GetUserAirlineStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAirlineStatsQuery, GetUserAirlineStatsQueryVariables>(GetUserAirlineStatsDocument, options);
      }
export function useGetUserAirlineStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAirlineStatsQuery, GetUserAirlineStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAirlineStatsQuery, GetUserAirlineStatsQueryVariables>(GetUserAirlineStatsDocument, options);
        }
export function useGetUserAirlineStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserAirlineStatsQuery, GetUserAirlineStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserAirlineStatsQuery, GetUserAirlineStatsQueryVariables>(GetUserAirlineStatsDocument, options);
        }
export type GetUserAirlineStatsQueryHookResult = ReturnType<typeof useGetUserAirlineStatsQuery>;
export type GetUserAirlineStatsLazyQueryHookResult = ReturnType<typeof useGetUserAirlineStatsLazyQuery>;
export type GetUserAirlineStatsSuspenseQueryHookResult = ReturnType<typeof useGetUserAirlineStatsSuspenseQuery>;
export type GetUserAirlineStatsQueryResult = Apollo.QueryResult<GetUserAirlineStatsQuery, GetUserAirlineStatsQueryVariables>;
export const GetUserDistinctCountsDocument = gql`
    query GetUserDistinctCounts($includeFutureFlights: Boolean = true) {
  userDistinctCounts(includeFutureFlights: $includeFutureFlights) {
    airlineCount
    flightCount
    airportCount
  }
}
    `;

/**
 * __useGetUserDistinctCountsQuery__
 *
 * To run a query within a React component, call `useGetUserDistinctCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDistinctCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDistinctCountsQuery({
 *   variables: {
 *      includeFutureFlights: // value for 'includeFutureFlights'
 *   },
 * });
 */
export function useGetUserDistinctCountsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserDistinctCountsQuery, GetUserDistinctCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDistinctCountsQuery, GetUserDistinctCountsQueryVariables>(GetUserDistinctCountsDocument, options);
      }
export function useGetUserDistinctCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDistinctCountsQuery, GetUserDistinctCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDistinctCountsQuery, GetUserDistinctCountsQueryVariables>(GetUserDistinctCountsDocument, options);
        }
export function useGetUserDistinctCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserDistinctCountsQuery, GetUserDistinctCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserDistinctCountsQuery, GetUserDistinctCountsQueryVariables>(GetUserDistinctCountsDocument, options);
        }
export type GetUserDistinctCountsQueryHookResult = ReturnType<typeof useGetUserDistinctCountsQuery>;
export type GetUserDistinctCountsLazyQueryHookResult = ReturnType<typeof useGetUserDistinctCountsLazyQuery>;
export type GetUserDistinctCountsSuspenseQueryHookResult = ReturnType<typeof useGetUserDistinctCountsSuspenseQuery>;
export type GetUserDistinctCountsQueryResult = Apollo.QueryResult<GetUserDistinctCountsQuery, GetUserDistinctCountsQueryVariables>;
export const ListAirportsMinimalDocument = gql`
    query ListAirportsMinimal($filter: AirportFilterInput, $sort: AirportSortInput, $pagination: PaginationInput) {
  airports(filter: $filter, sort: $sort, pagination: $pagination) {
    edges {
      node {
        ...AirportBasic
      }
      cursor
    }
    pageInfo {
      currentPage
      totalPages
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    ${AirportBasicFragmentDoc}`;

/**
 * __useListAirportsMinimalQuery__
 *
 * To run a query within a React component, call `useListAirportsMinimalQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAirportsMinimalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAirportsMinimalQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListAirportsMinimalQuery(baseOptions?: Apollo.QueryHookOptions<ListAirportsMinimalQuery, ListAirportsMinimalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAirportsMinimalQuery, ListAirportsMinimalQueryVariables>(ListAirportsMinimalDocument, options);
      }
export function useListAirportsMinimalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAirportsMinimalQuery, ListAirportsMinimalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAirportsMinimalQuery, ListAirportsMinimalQueryVariables>(ListAirportsMinimalDocument, options);
        }
export function useListAirportsMinimalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAirportsMinimalQuery, ListAirportsMinimalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAirportsMinimalQuery, ListAirportsMinimalQueryVariables>(ListAirportsMinimalDocument, options);
        }
export type ListAirportsMinimalQueryHookResult = ReturnType<typeof useListAirportsMinimalQuery>;
export type ListAirportsMinimalLazyQueryHookResult = ReturnType<typeof useListAirportsMinimalLazyQuery>;
export type ListAirportsMinimalSuspenseQueryHookResult = ReturnType<typeof useListAirportsMinimalSuspenseQuery>;
export type ListAirportsMinimalQueryResult = Apollo.QueryResult<ListAirportsMinimalQuery, ListAirportsMinimalQueryVariables>;
export const GetAirportDetailDocument = gql`
    query GetAirportDetail($id: ID!) {
  airport(id: $id) {
    ...AirportDetail
  }
}
    ${AirportDetailFragmentDoc}`;

/**
 * __useGetAirportDetailQuery__
 *
 * To run a query within a React component, call `useGetAirportDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAirportDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAirportDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAirportDetailQuery(baseOptions: Apollo.QueryHookOptions<GetAirportDetailQuery, GetAirportDetailQueryVariables> & ({ variables: GetAirportDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAirportDetailQuery, GetAirportDetailQueryVariables>(GetAirportDetailDocument, options);
      }
export function useGetAirportDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAirportDetailQuery, GetAirportDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAirportDetailQuery, GetAirportDetailQueryVariables>(GetAirportDetailDocument, options);
        }
export function useGetAirportDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAirportDetailQuery, GetAirportDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAirportDetailQuery, GetAirportDetailQueryVariables>(GetAirportDetailDocument, options);
        }
export type GetAirportDetailQueryHookResult = ReturnType<typeof useGetAirportDetailQuery>;
export type GetAirportDetailLazyQueryHookResult = ReturnType<typeof useGetAirportDetailLazyQuery>;
export type GetAirportDetailSuspenseQueryHookResult = ReturnType<typeof useGetAirportDetailSuspenseQuery>;
export type GetAirportDetailQueryResult = Apollo.QueryResult<GetAirportDetailQuery, GetAirportDetailQueryVariables>;
export const GetAirportsMinimalDocument = gql`
    query GetAirportsMinimal($ids: [ID!]!) {
  airportsByIds(ids: $ids) {
    ...AirportBasic
  }
}
    ${AirportBasicFragmentDoc}`;

/**
 * __useGetAirportsMinimalQuery__
 *
 * To run a query within a React component, call `useGetAirportsMinimalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAirportsMinimalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAirportsMinimalQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetAirportsMinimalQuery(baseOptions: Apollo.QueryHookOptions<GetAirportsMinimalQuery, GetAirportsMinimalQueryVariables> & ({ variables: GetAirportsMinimalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAirportsMinimalQuery, GetAirportsMinimalQueryVariables>(GetAirportsMinimalDocument, options);
      }
export function useGetAirportsMinimalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAirportsMinimalQuery, GetAirportsMinimalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAirportsMinimalQuery, GetAirportsMinimalQueryVariables>(GetAirportsMinimalDocument, options);
        }
export function useGetAirportsMinimalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAirportsMinimalQuery, GetAirportsMinimalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAirportsMinimalQuery, GetAirportsMinimalQueryVariables>(GetAirportsMinimalDocument, options);
        }
export type GetAirportsMinimalQueryHookResult = ReturnType<typeof useGetAirportsMinimalQuery>;
export type GetAirportsMinimalLazyQueryHookResult = ReturnType<typeof useGetAirportsMinimalLazyQuery>;
export type GetAirportsMinimalSuspenseQueryHookResult = ReturnType<typeof useGetAirportsMinimalSuspenseQuery>;
export type GetAirportsMinimalQueryResult = Apollo.QueryResult<GetAirportsMinimalQuery, GetAirportsMinimalQueryVariables>;
export const GetUserAirportStatsDocument = gql`
    query GetUserAirportStats($filter: UserAirportStatsFilterInput, $sort: UserAirportStatsSortInput, $pagination: PaginationInput) {
  userAirportStats(filter: $filter, sort: $sort, pagination: $pagination) {
    edges {
      node {
        airport {
          ...AirportBasic
        }
        flightCountPast
        flightCountFuture
        lastFlightDate
      }
      cursor
    }
    pageInfo {
      currentPage
      totalPages
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    ${AirportBasicFragmentDoc}`;

/**
 * __useGetUserAirportStatsQuery__
 *
 * To run a query within a React component, call `useGetUserAirportStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAirportStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAirportStatsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetUserAirportStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserAirportStatsQuery, GetUserAirportStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAirportStatsQuery, GetUserAirportStatsQueryVariables>(GetUserAirportStatsDocument, options);
      }
export function useGetUserAirportStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAirportStatsQuery, GetUserAirportStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAirportStatsQuery, GetUserAirportStatsQueryVariables>(GetUserAirportStatsDocument, options);
        }
export function useGetUserAirportStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserAirportStatsQuery, GetUserAirportStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserAirportStatsQuery, GetUserAirportStatsQueryVariables>(GetUserAirportStatsDocument, options);
        }
export type GetUserAirportStatsQueryHookResult = ReturnType<typeof useGetUserAirportStatsQuery>;
export type GetUserAirportStatsLazyQueryHookResult = ReturnType<typeof useGetUserAirportStatsLazyQuery>;
export type GetUserAirportStatsSuspenseQueryHookResult = ReturnType<typeof useGetUserAirportStatsSuspenseQuery>;
export type GetUserAirportStatsQueryResult = Apollo.QueryResult<GetUserAirportStatsQuery, GetUserAirportStatsQueryVariables>;
export const ListFlightsMinimalDocument = gql`
    query ListFlightsMinimal($sort: FlightSortInput, $pagination: PaginationInput) {
  flights(sort: $sort, pagination: $pagination) {
    edges {
      node {
        ...FlightBasic
        userFlight {
          id
          seatNumber
          travelClass
          notes
        }
      }
      cursor
    }
    pageInfo {
      currentPage
      totalPages
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    ${FlightBasicFragmentDoc}`;

/**
 * __useListFlightsMinimalQuery__
 *
 * To run a query within a React component, call `useListFlightsMinimalQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFlightsMinimalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListFlightsMinimalQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListFlightsMinimalQuery(baseOptions?: Apollo.QueryHookOptions<ListFlightsMinimalQuery, ListFlightsMinimalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListFlightsMinimalQuery, ListFlightsMinimalQueryVariables>(ListFlightsMinimalDocument, options);
      }
export function useListFlightsMinimalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListFlightsMinimalQuery, ListFlightsMinimalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListFlightsMinimalQuery, ListFlightsMinimalQueryVariables>(ListFlightsMinimalDocument, options);
        }
export function useListFlightsMinimalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListFlightsMinimalQuery, ListFlightsMinimalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListFlightsMinimalQuery, ListFlightsMinimalQueryVariables>(ListFlightsMinimalDocument, options);
        }
export type ListFlightsMinimalQueryHookResult = ReturnType<typeof useListFlightsMinimalQuery>;
export type ListFlightsMinimalLazyQueryHookResult = ReturnType<typeof useListFlightsMinimalLazyQuery>;
export type ListFlightsMinimalSuspenseQueryHookResult = ReturnType<typeof useListFlightsMinimalSuspenseQuery>;
export type ListFlightsMinimalQueryResult = Apollo.QueryResult<ListFlightsMinimalQuery, ListFlightsMinimalQueryVariables>;
export const GetFlightDetailDocument = gql`
    query GetFlightDetail($id: ID!) {
  flight(id: $id) {
    ...FlightDetail
  }
}
    ${FlightDetailFragmentDoc}`;

/**
 * __useGetFlightDetailQuery__
 *
 * To run a query within a React component, call `useGetFlightDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFlightDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFlightDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFlightDetailQuery(baseOptions: Apollo.QueryHookOptions<GetFlightDetailQuery, GetFlightDetailQueryVariables> & ({ variables: GetFlightDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFlightDetailQuery, GetFlightDetailQueryVariables>(GetFlightDetailDocument, options);
      }
export function useGetFlightDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFlightDetailQuery, GetFlightDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFlightDetailQuery, GetFlightDetailQueryVariables>(GetFlightDetailDocument, options);
        }
export function useGetFlightDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFlightDetailQuery, GetFlightDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFlightDetailQuery, GetFlightDetailQueryVariables>(GetFlightDetailDocument, options);
        }
export type GetFlightDetailQueryHookResult = ReturnType<typeof useGetFlightDetailQuery>;
export type GetFlightDetailLazyQueryHookResult = ReturnType<typeof useGetFlightDetailLazyQuery>;
export type GetFlightDetailSuspenseQueryHookResult = ReturnType<typeof useGetFlightDetailSuspenseQuery>;
export type GetFlightDetailQueryResult = Apollo.QueryResult<GetFlightDetailQuery, GetFlightDetailQueryVariables>;
export const DeleteUserFlightDocument = gql`
    mutation DeleteUserFlight($id: ID!) {
  deleteUserFlight(id: $id)
}
    `;
export type DeleteUserFlightMutationFn = Apollo.MutationFunction<DeleteUserFlightMutation, DeleteUserFlightMutationVariables>;

/**
 * __useDeleteUserFlightMutation__
 *
 * To run a mutation, you first call `useDeleteUserFlightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserFlightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserFlightMutation, { data, loading, error }] = useDeleteUserFlightMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserFlightMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserFlightMutation, DeleteUserFlightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserFlightMutation, DeleteUserFlightMutationVariables>(DeleteUserFlightDocument, options);
      }
export type DeleteUserFlightMutationHookResult = ReturnType<typeof useDeleteUserFlightMutation>;
export type DeleteUserFlightMutationResult = Apollo.MutationResult<DeleteUserFlightMutation>;
export type DeleteUserFlightMutationOptions = Apollo.BaseMutationOptions<DeleteUserFlightMutation, DeleteUserFlightMutationVariables>;